import React from 'react';
import { checkSetState } from '@teammo/teammo-general-utils';
import { Card } from 'reactstrap';
import Button from 'app/components/general/Button';
import Tbody from 'app/components/general/Tbody';
import TeamMemberRow from 'app/components/teamMembers/TeamMemberRow';
import AddTeamMemberRow from 'app/components/teamMembers/AddTeamMemberRow';
import ShareLink from 'app/components/teams/ShareLink';
import SectionGroup from 'app/components/general/SectionGroup';

interface IManageTeamMembersProps {
  actions: any;
  currentTeam?: any;
  currentUser?: any;
  currentClub?: any;
  errors?: any;
  isLoading: boolean;
  teamMembersById?: any;
  teamMemberIds?: string[];
  showAddTeamMember: boolean;
  teamId?: string;
}

interface IManageTeamMembersState {
  showAddTeamMember: boolean;
  teamMemberIds: string[];
}

export default class ManageTeamMembers extends React.Component<IManageTeamMembersProps, IManageTeamMembersState> {
  static defaultProps: IManageTeamMembersProps = {
    actions: undefined,
    currentTeam: {},
    currentUser: {},
    currentClub: {},
    isLoading: false,
    teamMembersById: undefined,
    teamMemberIds: undefined,
    showAddTeamMember: undefined,
    teamId: undefined,
    errors: {},
  };

  state: IManageTeamMembersState = {
    showAddTeamMember: this.props.showAddTeamMember || false,
    teamMemberIds: this.props.teamMemberIds || undefined,
  }

  static getDerivedStateFromProps(nextProps, prevState): any {
    if (!nextProps.isLoading && !!nextProps.teamMemberIds && prevState.teamMemberIds.length !== nextProps.teamMemberIds.length) {
      return {
        ...prevState,
        showAddTeamMember: false,
        teamMemberIds: nextProps.teamMemberIds,
      };
    }
    return null;
  }

  componentDidMount(): void {
    this.props.actions.getAllTeamMembers(
      {
        filter: { 'team-id': this.props.currentTeam.id },
        page: {
          size: 200,
        },
      },
      false,
    );
  }

  handleAddTeamMember = (): void => {
    this.setState({ showAddTeamMember: true });
  }

  handleCancelTeamMember = (): void => {
    this.setState({ showAddTeamMember: false });
  }

  teammoShareUrl(): string {
    return `${JOIN_URL}/${this.props.currentTeam.inviteToken}`;
  }

  renderTeamMemberRow(teamMemberId): React.ReactNode {
    if (this.props.teamMembersById !== undefined) {
      const teamMember = this.props.teamMembersById[teamMemberId];
      if (teamMember) {
        return (
          <TeamMemberRow
            key={teamMember.id}
            fullName={teamMember.fullName}
            email={teamMember.email}
            mobile={teamMember.mobile}
            updatedAt={teamMember.updatedAt}
            teamMemberId={teamMember.id}
            teamId={this.props.teamId}
            updateTeamMember={this.props.actions.updateTeamMember}
            deleteTeamMember={this.props.actions.deleteTeamMember}
            isLoading={this.props.isLoading}
            editable={this.props.isLoading}
            owes="0"
          />
        );
      }
    }
    return null;
  }

  renderTeamMemberList(): React.ReactNode {
    if (this.props.teamMemberIds !== undefined) {
      return this.props.teamMemberIds.map((id) => this.renderTeamMemberRow(id));
    }
    return null;
  }

  renderCreateTeamMemberRow(): React.ReactNode {
    if (this.state.showAddTeamMember) {
      return (
        <AddTeamMemberRow
          {...this.props}
          createTeamMember={this.props.actions.createTeamMember}
          teamId={this.props.currentTeam.id}
          clubId={this.props.currentClub.id}
          isLoading={this.props.isLoading}
          cancelTeamMember={this.handleCancelTeamMember}
        />
      );
    }
    return null;
  }

  render(): React.ReactNode {
    return (
      <SectionGroup
        title="Your Team"
        buttons={(
          <div className="row">
            <div className="col btn-flex-group">
              <div className="btn-flex-container thin-margin">
                {!this.state.showAddTeamMember && (
                  <Button
                    className="btn-1 btn-thinner"
                    onClick={this.handleAddTeamMember}
                  >
                    Add Team Member
                  </Button>
                )}
                <ShareLink link={this.teammoShareUrl()} />
              </div>
            </div>
          </div>
        )}
      >
        <div className="row head-row">
          <div className="col col-6 col-sm-3">Name</div>
          <div className="col col-2 d-none d-sm-block">Mobile</div>
          <div className="col col-3 d-none d-sm-block">Email</div>
          <div className="col col-6 col-sm-4" />
        </div>
        <Tbody
          name="team members"
          showNoRows={
            !this.state.showAddTeamMember
            && this.props.teamMemberIds !== undefined
            && this.props.teamMemberIds.length === 0
          }
        >
          {this.renderCreateTeamMemberRow()}
          {this.renderTeamMemberList()}
        </Tbody>
      </SectionGroup>
    );
  }
}
